import { render, staticRenderFns } from "./PricingRequestsPopups.vue?vue&type=template&id=7b895996&lang=pug"
import script from "./PricingRequestsPopups.vue?vue&type=script&lang=ts"
export * from "./PricingRequestsPopups.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports